import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";


const usePaginationWrapper = ({ defaultLimit }) => {
  const [pageable, setPageable] = useState();
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(defaultLimit || 10);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [numberOfElements, setNumberOfElements] = useState(0);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText] = useDebounce(searchText, 300);

  const pageOptions = [
    { value: defaultLimit, label: `${defaultLimit} Rows` },
    { value: defaultLimit * 2, label: `${defaultLimit * 2} Rows` },
    { value: defaultLimit * 3, label: `${defaultLimit * 3} Rows` },
  ];

  useEffect(() => {
    if (pageable) {
      // setLast(pageable.last);
      // setFirst(pageable.first);
      setTotalElements(pageable.total_elements);
      setTotalPages(pageable.total_pages);
      setNumberOfElements(pageable.number_of_elements);
      // setPage(pageable.number);
    }
  }, [pageable]);

  useEffect(() => {
    setOffset(0);
    setLimit(defaultLimit || 10);
  }, [debouncedSearchText, defaultLimit]);

  return {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  };
};

export default usePaginationWrapper;
